import { render, staticRenderFns } from "./GiftRedeem.vue?vue&type=template&id=22fe3482&scoped=true&"
import script from "./GiftRedeem.vue?vue&type=script&lang=js&"
export * from "./GiftRedeem.vue?vue&type=script&lang=js&"
import style0 from "./GiftRedeem.vue?vue&type=style&index=0&id=22fe3482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe3482",
  null
  
)

export default component.exports